export default "__VITE_ASSET__93a34dcb__"